import { Button, Form, Grid, Input } from "basis";
import { Dispatch } from "react";
import { useEventTracking, usePageTracking } from "react-event-tracker";
import { ProgressBar } from "../../ProgressBar/ProgressBar";
import styles from "../registration.module.scss";
import { Actions, NEXT_SCREEN, PAGES } from "./actions";
import { isAlpha, isEmail } from "./validator";

interface Props {
  steps: number[];
  currentStep: number;
  errorMsg: string;
  dispatch: Dispatch<Actions>;
  userDetails: { name: string; email: string };
  setScreen: (screenName: string) => void;
}

export const YourDetailsComponent = ({
  steps,
  currentStep,
  errorMsg,
  dispatch,
  userDetails,
  setScreen,
}: Props) => {
  const { trackEvent } = useEventTracking();
  return (
    <div>
      <ProgressBar steps={steps} currentStep={currentStep} />
      <h1 className={`h4 ${styles.h4} ${styles.formHeading}`}>Your details</h1>
      <Form
        initialValues={userDetails}
        onSubmit={({ values, errors }) => {
          if (Object.keys(errors).length === 0)
            dispatch({
              type: NEXT_SCREEN,
              payload: {
                currentScreen: PAGES.PASSWORD,
                errorMsg: "",
                ...values,
              },
            });
        }}
      >
        <div className={styles.content}>
          {errorMsg && (
            <div
              className={`body02 ${styles.error}`}
              data-trackid="registration-error"
            >
              {errorMsg}
            </div>
          )}
          <span className={`body02 ${styles.subText}`}>
            This will be your Latitude ID to log in
          </span>
        </div>
        <Input name="name" label="Name" validate={isAlpha} testId="name" />
        <Input
          type="email"
          name="email"
          label="Email"
          validate={isEmail}
          testId="email"
        />
        <Grid cols="2" cols-sm="160px 160px" colsGap="8" margin="8 0 0 0">
          <Grid.Item colSpan="0">
            <Button
              width="100%"
              type="submit"
              onClick={() => {
                trackEvent({
                  event: {
                    category: "application",
                    action: "application-next",
                    location: "Your details",
                    label: "Next",
                  },
                });
              }}
            >
              Next
            </Button>
          </Grid.Item>
          <Grid.Item colSpan="1">
            <Button
              variant="secondary"
              onClick={() => {
                setScreen("TermOfUse");
                trackEvent({
                  event: {
                    category: "application",
                    action: "application-back",
                    location: "Your details",
                    label: "Back",
                  },
                });
              }}
            >
              Back
            </Button>
          </Grid.Item>
        </Grid>
      </Form>
    </div>
  );
};

export const YourDetails = (props: Props) => {
  usePageTracking({
    page: {
      pageType: "input-page",
      siteSection: "registration",
      siteSubSection: "",
      pageTitle: "details",
    },
    user: {
      authenticationStatus: "not logged in",
    },
  });

  return <YourDetailsComponent {...props} />;
};
